/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Team_ResponseInputs */

const es_feedback_modal_team_response = /** @type {(inputs: Feedback_Modal_Team_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta del equipo`)
};

const en_feedback_modal_team_response = /** @type {(inputs: Feedback_Modal_Team_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team response`)
};

/**
* | output |
* | --- |
* | "Team response" |
*
* @param {Feedback_Modal_Team_ResponseInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_team_response = /** @type {((inputs?: Feedback_Modal_Team_ResponseInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Team_ResponseInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_team_response(inputs)
	return en_feedback_modal_team_response(inputs)
});
export { feedback_modal_team_response as "feedback.modal.team_response" }